import script from "./Nationality.vue?vue&type=script&setup=true&lang=js"
export * from "./Nationality.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__